import NewReportTypes from './NewReport.types';

// ========== ATTENDANCE REPORT ACTIONS START ==========
export const getAttendanceReportStart = (data: any) => ({
	type: NewReportTypes.GET_ATTENDANCE_REPORT_START,
	payload: data,
});

export const getAttendanceReportSuccess = (data: any) => ({
	type: NewReportTypes.GET_ATTENDANCE_REPORT_SUCCESS,
	payload: data,
});

export const getAttendanceReportFailure = (error: unknown) => ({
	type: NewReportTypes.GET_ATTENDANCE_REPORT_FAILURE,
	payload: error,
});
// ========== ATTENDANCE REPORT ACTIONS END ==========

// ========== LEAVE REPORT ACTIONS START ==========
export const getLeaveReportStart = (data: any) => ({
	type: NewReportTypes.GET_LEAVE_REPORT_START,
	payload: data,
});

export const getLeaveReportSuccess = (data: any) => ({
	type: NewReportTypes.GET_LEAVE_REPORT_SUCCESS,
	payload: data,
});

export const getLeaveReportFailure = (error: unknown) => ({
	type: NewReportTypes.GET_LEAVE_REPORT_FAILURE,
	payload: error,
});
// ========== LEAVE REPORT ACTIONS END ==========

// ========== SECTION WISE ATTENDANCE REPORT ACTIONS START ==========
export const getSectionWiseAttendanceReportStart = (data: any) => ({
	type: NewReportTypes.GET_SECTION_WISE_ATTENDANCE_REPORT_START,
	payload: data,
});

export const getSectionWiseAttendanceReportSuccess = (data: any) => ({
	type: NewReportTypes.GET_SECTION_WISE_ATTENDANCE_REPORT_SUCCESS,
	payload: data,
});

export const getSectionWiseAttendanceReportFailure = (error: unknown) => ({
	type: NewReportTypes.GET_SECTION_WISE_ATTENDANCE_REPORT_FAILURE,
	payload: error,
});

// ========== SECTION WISE ATTENDANCE REPORT ACTIONS END ==========

// ========== MANAGEMENT LEAVE REPORT ACTIONS START ==========
export const getManagementLeaveReportStart = (data: any) => ({
    type: NewReportTypes.GET_MANAGEMENT_LEAVE_REPORT_START,
    payload: data,
});

export const getManagementLeaveReportSuccess = (data: any) => ({
    type: NewReportTypes.GET_MANAGEMENT_LEAVE_REPORT_SUCCESS,
    payload: data,
});

export const getManagementLeaveReportFailure = (error: unknown) => ({
    type: NewReportTypes.GET_MANAGEMENT_LEAVE_REPORT_FAILURE,
    payload: error,
});
// ========== MANAGEMENT LEAVE REPORT ACTIONS END ==========

// ========== DESIGNATION WISE LEAVE REPORT ACTIONS START ==========
export const getDesignationWiseLeaveReportStart = (data: any) => ({
    type: NewReportTypes.GET_DESIGNATION_WISE_LEAVE_REPORT_START,
    payload: data,
});

export const getDesignationWiseLeaveReportSuccess = (data: any) => ({
    type: NewReportTypes.GET_DESIGNATION_WISE_LEAVE_REPORT_SUCCESS,
    payload: data,
});

export const getDesignationWiseLeaveReportFailure = (error: unknown) => ({
    type: NewReportTypes.GET_DESIGNATION_WISE_LEAVE_REPORT_FAILURE,
    payload: error,
});
// ========== DESIGNATION WISE LEAVE REPORT ACTIONS END ==========

// ========== EMPLOYEE LEAVE REPORT ACTIONS START ==========
export const getEmployeeLeaveReportStart = (data: any) => ({
    type: NewReportTypes.GET_EMPLOYEE_LEAVE_REPORT_START,
    payload: data,
});

export const getEmployeeLeaveReportSuccess = (data: any) => ({
    type: NewReportTypes.GET_EMPLOYEE_LEAVE_REPORT_SUCCESS,
    payload: data,
});

export const getEmployeeLeaveReportFailure = (error: unknown) => ({
    type: NewReportTypes.GET_EMPLOYEE_LEAVE_REPORT_FAILURE,
    payload: error,
});
// ========== EMPLOYEE LEAVE REPORT ACTIONS END ==========

// ========== MONTHLY ATTENDANCE SUMMARY REPORT ACTIONS START ==========
export const getMonthlyAttendanceSummaryReportStart = (data: any) => ({
    type: NewReportTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_START,
    payload: data,
});

export const getMonthlyAttendanceSummaryReportSuccess = (data: any) => ({
    type: NewReportTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_SUCCESS,
    payload: data,
});

export const getMonthlyAttendanceSummaryReportFailure = (error: unknown) => ({
    type: NewReportTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_FAILURE,
    payload: error,
});
// ========== MONTHLY ATTENDANCE SUMMARY REPORT ACTIONS END ==========

// ========== MONTHLY CHECKOUT REPORT ACTIONS START ==========
export const getMonthlyCheckoutReportStart = (data: any) => ({
    type: NewReportTypes.GET_MONTHLY_CHECKOUT_REPORT_START,
    payload: data,
});

export const getMonthlyCheckoutReportSuccess = (data: any) => ({
    type: NewReportTypes.GET_MONTHLY_CHECKOUT_REPORT_SUCCESS,
    payload: data,
});

export const getMonthlyCheckoutReportFailure = (error: unknown) => ({
    type: NewReportTypes.GET_MONTHLY_CHECKOUT_REPORT_FAILURE,
    payload: error,
});
// ========== MONTHLY CHECKOUT REPORT ACTIONS END ==========

// ========== MONTHLY CHECKOUT DETAILS ACTIONS START ==========
export const getMonthlyCheckoutDetailsStart = (data: any) => ({
    type: NewReportTypes.GET_MONTHLY_CHECKOUT_DETAILS_START,
    payload: data,
});

export const getMonthlyCheckoutDetailsSuccess = (data: any) => ({
    type: NewReportTypes.GET_MONTHLY_CHECKOUT_DETAILS_SUCCESS,
    payload: data,
});

export const getMonthlyCheckoutDetailsFailure = (error: unknown) => ({
    type: NewReportTypes.GET_MONTHLY_CHECKOUT_DETAILS_FAILURE,
    payload: error,
});
// ========== MONTHLY CHECKOUT DETAILS ACTIONS END ==========

// ========== COMP OFF REPORT ACTIONS START ==========
export const getCompOffReportStart = (data: any) => ({
    type: NewReportTypes.GET_COMPOFF_REPORT_START,
    payload: data,
});

export const getCompOffReportSuccess = (data: any) => ({
    type: NewReportTypes.GET_COMPOFF_REPORT_SUCCESS,
    payload: data,
});

export const getCompOffReportFailure = (error: unknown) => ({
    type: NewReportTypes.GET_COMPOFF_REPORT_FAILURE,
    payload: error,
});
// ========== COMP OFF REPORT ACTIONS END ==========

// ========== APPROVE COMP OFF BY HR ACTIONS START ==========
export const approveCompOffByHRStart = (data: any) => ({
	type: NewReportTypes.APPROVE_COMPOFF_BY_HR_START,
	payload: data,
});

export const approveCompOffByHRSuccess = (data: any) => ({
	type: NewReportTypes.APPROVE_COMPOFF_BY_HR_SUCCESS,
	payload: data,
});

export const approveCompOffByHRFailure = (error: unknown) => ({
	type: NewReportTypes.APPROVE_COMPOFF_BY_HR_FAILURE,
	payload: error,
});

export const approveCompOffByHRResponseRestStart = () => ({
	type: NewReportTypes.APPROVE_COMPOFF_BY_HR_RESPONSE_REST_START,
});
// ========== APPROVE COMP OFF BY HR ACTIONS END ==========

// ========== REFRESHMENT REPORT ACTIONS START ==========
export const getRefreshmentReportStart = (data: any) => ({
    type: NewReportTypes.GET_REFRESHMENT_REPORT_START,
    payload: data,
});

export const getRefreshmentReportSuccess = (data: any) => ({
    type: NewReportTypes.GET_REFRESHMENT_REPORT_SUCCESS,
    payload: data,
});

export const getRefreshmentReportFailure = (error: unknown) => ({
    type: NewReportTypes.GET_REFRESHMENT_REPORT_FAILURE,
    payload: error,
});
// ========== REFRESHMENT REPORT ACTIONS END ==========

// ========== ON DUTY REPORT ACTIONS START ==========
export const getOnDutyReportStart = (data: any) => ({
	type: NewReportTypes.GET_ONDUTY_REPORT_START,
	payload: data,
});

export const getOnDutyReportSuccess = (data: any) => ({
	type: NewReportTypes.GET_ONDUTY_REPORT_SUCCESS,
	payload: data,
});

export const getOnDutyReportFailure = (error: unknown) => ({
	type: NewReportTypes.GET_ONDUTY_REPORT_FAILURE,
	payload: error,
});
// ========== ON DUTY REPORT ACTIONS END ==========

// ========== GET ALL EMPLOYEES CHECK-IN/CHECK-OUT ACTIONS START ==========
export const getAllEmployeesCheckInOutStart = (data: any) => ({
	type: NewReportTypes.GET_ALL_EMPLOYEES_CHECKINOUT_START,
	payload: data,
});

export const getAllEmployeesCheckInOutSuccess = (data: any) => ({
	type: NewReportTypes.GET_ALL_EMPLOYEES_CHECKINOUT_SUCCESS,
	payload: data,
});

export const getAllEmployeesCheckInOutFailure = (error: unknown) => ({
	type: NewReportTypes.GET_ALL_EMPLOYEES_CHECKINOUT_FAILURE,
	payload: error,
});
// ========== GET ALL EMPLOYEES CHECK-IN/CHECK-OUT ACTIONS END ==========

// ========== CHECK-IN LOCKED REPORT ACTIONS START ==========
export const checkInLockedStart = (data: any) => ({
	type: NewReportTypes.CHECK_IN_LOCKED_START,
	payload: data,
});

export const checkInLockedSuccess = (data: any) => ({
	type: NewReportTypes.CHECK_IN_LOCKED_SUCCESS,
	payload: data,
});

export const checkInLockedFailure = (error: unknown) => ({
	type: NewReportTypes.CHECK_IN_LOCKED_FAILURE,
	payload: error,
});

export const checkInLockedResponseChanged = () => ({
	type: NewReportTypes.CHECK_IN_LOCKED_RESPONSE_CHANGED,
});

export const checkInLockedHistoryStart = (data: any) => ({
	type: NewReportTypes.CHECK_IN_LOCKED_HISTORY_START,
	payload: data,
});

export const checkInLockedHistorySuccess = (data: any) => ({
	type: NewReportTypes.CHECK_IN_LOCKED_HISTORY_SUCCESS,
	payload: data,
});

export const checkInLockedHistoryFailure = (error: unknown) => ({
	type: NewReportTypes.CHECK_IN_LOCKED_HISTORY_FAILURE,
	payload: error,
});

export const checkInLockedExcuseStart = (data: any) => ({
	type: NewReportTypes.CHECK_IN_LOCKED_EXCUSE_START,
	payload: data,
});

export const checkInLockedExcuseSuccess = (data: any) => ({
	type: NewReportTypes.CHECK_IN_LOCKED_EXCUSE_SUCCESS,
	payload: data,
});

export const checkInLockedExcuseFailure = (error: unknown) => ({
	type: NewReportTypes.CHECK_IN_LOCKED_EXCUSE_FAILURE,
	payload: error,
});

export const checkInLockedExcuseResponseChanged = () => ({
	type: NewReportTypes.CHECK_IN_LOCKED_EXCUSE_RESPONSE_CHANGED,
});

export const checkInUnLockedHistoryStart = (data: any) => ({
	type: NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_START,
	payload: data,
});

export const checkInUnLockedHistorySuccess = (data: any) => ({
	type: NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_SUCCESS,
	payload: data,
});

export const checkInUnLockedHistoryFailure = (error: unknown) => ({
	type: NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_FAILURE,
	payload: error,
});

export const checkInUnLockedHistoryResponseChanged = () => ({
	type: NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_RESPONSE_CHANGED,
});

export const checkInUnLockedHistoryResponseChangedReset = () => ({
	type: NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_RESPONSE_CHANGED_RESET,
});
// ========== CHECK-IN LOCKED REPORT ACTIONS END ==========

// ========== FESTIVAL ADVANCE REPORT ACTIONS START ==========
export const getFestivalAdvanceReportStart = (data: any) => ({
	type: NewReportTypes.GET_FESTIVAL_ADVANCE_REPORT_START,
	payload: data,
});

export const getFestivalAdvanceReportSuccess = (data: any) => ({
	type: NewReportTypes.GET_FESTIVAL_ADVANCE_REPORT_SUCCESS,
	payload: data,
});

export const getFestivalAdvanceReportFailure = (error: unknown) => ({
	type: NewReportTypes.GET_FESTIVAL_ADVANCE_REPORT_FAILURE,
	payload: error,
});
// ========== FESTIVAL ADVANCE REPORT ACTIONS END ==========

// ========== GET ALL FESTIVAL NAMES ACTIONS START ==========
export const getAllFestivalNamesStart = (data: any) => ({
	type: NewReportTypes.GET_ALL_FESTIVAL_NAMES_START,
	payload: data,
});

export const getAllFestivalNamesSuccess = (data: any) => ({
	type: NewReportTypes.GET_ALL_FESTIVAL_NAMES_SUCCESS,
	payload: data,
});

export const getAllFestivalNamesFailure = (error: unknown) => ({
	type: NewReportTypes.GET_ALL_FESTIVAL_NAMES_FAILURE,
	payload: error,
});
// ========== GET ALL FESTIVAL NAMES ACTIONS END ==========

// ========== UPDATE FESTIVAL ADVANCE STATUS ACTIONS START ==========
export const updateFestivalAdvanceStatusStart = (data: any) => ({
	type: NewReportTypes.UPDATE_FESTIVAL_ADVANCE_STATUS_START,
	payload: data,
});

export const updateFestivalAdvanceStatusSuccess = (data: any) => ({
	type: NewReportTypes.UPDATE_FESTIVAL_ADVANCE_STATUS_SUCCESS,
	payload: data,
});

export const updateFestivalAdvanceStatusFailure = (error: unknown) => ({
	type: NewReportTypes.UPDATE_FESTIVAL_ADVANCE_STATUS_FAILURE,
	payload: error,
});
// ========== UPDATE FESTIVAL ADVANCE STATUS ACTIONS END ==========

// ========== MEDICAL ALLOWANCE REPORT ACTIONS START ==========
export const getMedicalAllowanceReportStart = (data: any) => ({
	type: NewReportTypes.GET_MEDICAL_ALLOWANCE_REPORT_START,
	payload: data,
});

export const getMedicalAllowanceReportSuccess = (data: any) => ({
	type: NewReportTypes.GET_MEDICAL_ALLOWANCE_REPORT_SUCCESS,
	payload: data,
});

export const getMedicalAllowanceReportFailure = (error: unknown) => ({
	type: NewReportTypes.GET_MEDICAL_ALLOWANCE_REPORT_FAILURE,
	payload: error,
});
// ========== MEDICAL ALLOWANCE REPORT ACTIONS END ==========

// ========== UPDATE MEDICAL ALLOWANCE STATUS ACTIONS START ==========
export const updateMedicalAllowanceStatusStart = (data: any) => ({
	type: NewReportTypes.UPDATE_MEDICAL_ALLOWANCE_STATUS_START,
	payload: data,
});

export const updateMedicalAllowanceStatusSuccess = (data: any) => ({
	type: NewReportTypes.UPDATE_MEDICAL_ALLOWANCE_STATUS_SUCCESS,
	payload: data,
});

export const updateMedicalAllowanceStatusFailure = (error: unknown) => ({
	type: NewReportTypes.UPDATE_MEDICAL_ALLOWANCE_STATUS_FAILURE,
	payload: error,
});
// ========== UPDATE MEDICAL ALLOWANCE STATUS ACTIONS END ==========